import type { ReactNode } from 'react';
import { Code } from '@customerio/pluma-components/react';
import { CopyToClipboard } from '@/components/copy-to-clipboard';

interface CopyableCodeProps {
  value: string;
  onCopy?: () => void;
  /** Table cells truncate (matches Ember); the reveal modal / webhook secret wrap so the full value is readable. */
  truncate?: boolean;
  /**
   * Non-sensitive namespace used to dedupe the copy snackbar. Never pass the raw
   * value here (it would end up in the snackbar's DOM id); use a stable context
   * label like `apiCredentials.trackApiKey`.
   */
  idNamespace?: string;
  children: ReactNode;
}

/**
 * Copyable `<Code>` used for credential values — site IDs, API keys, signing
 * secrets. Wraps the shared `CopyToClipboard` (matching how snippets use it),
 * so the copy button reveals on hover/focus.
 *
 * `fs-exclude` keeps the value out of FullStory session recordings.
 */
export const CopyableCode = ({
  value,
  onCopy,
  truncate = true,
  idNamespace = 'apiCredentials.code',
  children,
}: CopyableCodeProps) => (
  <CopyToClipboard content={value} onCopy={onCopy} idNamespace={idNamespace}>
    <Code truncate={truncate} className="fs-exclude">
      {children}
    </Code>
  </CopyToClipboard>
);
